<template>
    <v-tooltip bottom v-if="content !== null && content !== undefined && content !== ''">
        <template v-slot:activator="{ on }">
            <v-icon v-on="on">help</v-icon>
        </template>
        <div :style="'font-family:' + fontFamily">{{ content }}</div>
    </v-tooltip>
</template>

<script>
import {mapGetters, mapState} from "vuex"

export default {
    name: "HelpTooltip",
    props: ['content'],
    computed: {
        ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor'])
    }
}
</script>